<template>
  <div class="ped">

    <!-- ═══ Vista Listado ═══ -->
    <div v-if="!vistaPedido" style="display: flex; flex-direction: column; gap: 18px;">

      <!-- Header -->
      <div class="ped__header">
        <div class="ped__header-left">
          <div class="ped__icon-title">
            <i class="fa-solid fa-boxes-packing ped__section-icon ped__section-icon--primary"></i>
            <span class="ped__section-title">Pedidos Taller</span>
          </div>
        </div>
        <button class="ped__btn ped__btn--primary" @click="crearPedido()">
          <i class="fa-solid fa-plus"></i> Nuevo Pedido
        </button>
      </div>

      <!-- Filtros -->
      <div class="ped__card">
        <div class="ped__filters">
          <div class="ped__filter-item ped__filter-item--wide">
            <label class="ped__filter-label">Buscar</label>
            <b-form-input placeholder="Referencia, SKU..." v-model="buscar" size="sm" />
          </div>
        </div>

        <!-- Tabla -->
        <div class="ped__table-card">
          <div class="ped__tabla-scroll">
            <b-table
              :items="pedidosBusqueda"
              :fields="columnasTable"
              class="ped__table"
              no-border-collapse
              sort-icon-left
              hover
              ref="table"
            >

              <template #cell(referencia)="data">
                <span class="ped__ref" @click="editarPedido(data.item)">{{ data.item.referencia }}</span>
              </template>

              <template #cell(aceptado)="data">
                <span v-if="data.item.aceptado" class="ped__badge ped__badge--success">
                  <i class="fa-solid fa-check"></i> Si
                </span>
                <span v-else class="ped__badge ped__badge--pending">
                  <i class="fa-solid fa-clock"></i> Pendiente
                </span>
              </template>

              <template #cell(progreso)="data">
                <div class="ped__progress-wrap">
                  <div class="ped__progress-bar">
                    <div class="ped__progress-fill" :style="{ width: getProgreso(data.item) + '%' }"></div>
                  </div>
                  <span class="ped__progress-text">{{ data.item.finalizado }}/{{ data.item.total }}</span>
                </div>
              </template>

              <template #cell(options)="data">
                <div class="ped__actions">
                  <span class="ped__action ped__action--edit" v-b-tooltip.hover title="Editar" @click="editarPedido(data.item)">
                    <i class="fa-solid fa-pen-to-square"></i>
                  </span>
                  <span class="ped__action ped__action--accept" v-b-tooltip.hover title="Aceptar" @click="aceptarPedido(data.item)">
                    <i class="fa-solid fa-check"></i>
                  </span>
                  <span class="ped__action ped__action--expand" @click="data.toggleDetails">
                    <i :class="data.detailsShowing ? 'fa-solid fa-chevron-up' : 'fa-solid fa-chevron-down'"></i>
                  </span>
                  <span class="ped__action ped__action--delete" v-b-tooltip.hover title="Borrar" @click="deletePedido(data.item)">
                    <i class="fa-solid fa-trash"></i>
                  </span>
                  <span v-if="data.item.archivado == 1" class="ped__action ped__action--unarchive" v-b-tooltip.hover title="Desarchivar" @click="desArchivar(data.item)">
                    <i class="fa-solid fa-box-open"></i>
                  </span>
                </div>
              </template>

              <template #row-details="row">
                <div class="ped__details">
                  <div class="ped__details-table-wrap">
                    <b-table
                      :items="row.item.listaSku"
                      :fields="columnasSkus"
                      class="ped__table ped__table--nested"
                      no-border-collapse
                    />
                  </div>
                </div>
              </template>

            </b-table>
          </div>
        </div>
      </div>

    </div>

    <!-- ═══ Vista Detalle Pedido ═══ -->
    <div v-else style="display: flex; flex-direction: column; gap: 18px;">

      <!-- Header detalle -->
      <div class="ped__header">
        <div class="ped__header-left">
          <button class="ped__btn-icon" @click="vistaPedido = false" v-b-tooltip.hover title="Volver">
            <i class="fa-solid fa-arrow-left"></i>
          </button>
          <div class="ped__icon-title">
            <i class="fa-solid fa-box ped__section-icon ped__section-icon--primary"></i>
            <span class="ped__section-title">{{ pedidoSelect.referencia }}</span>
            <span class="ped__section-subtitle">| {{ pedidoSelect.fecha }}</span>
          </div>
        </div>
        <div class="ped__header-actions">
          <button class="ped__btn ped__btn--outline" @click="addSku()">
            <i class="fa-solid fa-plus"></i> Add SKU
          </button>
          <button class="ped__btn ped__btn--success" @click="guardarCambios()">
            <i class="fa-regular fa-floppy-disk"></i> Guardar
          </button>
        </div>
      </div>

      <!-- Tabla SKUs -->
      <div class="ped__card">
        <div class="ped__table-card">
          <div class="ped__tabla-scroll">
            <b-table
              :items="pedidoSelect.listaSku"
              :fields="columnasSkuPedido"
              class="ped__table"
              no-border-collapse
              sort-icon-left
              hover
              ref="table"
            >

              <template #cell(sku)="data">
                <v-select
                  v-if="data.item.nuevo"
                  v-model="data.item.sku"
                  :options="listSku"
                  placeholder="Seleccionar SKU"
                  menu-props="{ offsetY: true }"
                />
                <span v-else class="ped__sku-text">{{ data.item.sku }}</span>
              </template>

              <template #cell(cantidad)="data">
                <b-form-input
                  placeholder="0"
                  v-model="data.item.cantidad"
                  size="sm"
                  type="number"
                  class="ped__input-qty"
                />
              </template>

              <template #cell(fecha)="data">
                <b-form-datepicker
                  v-model="data.item.fecha"
                  :date-format-options="{ year: '2-digit', month: '2-digit', day: '2-digit' }"
                  size="sm"
                  class="ped__datepicker"
                />
              </template>

              <template #cell(options)="data">
                <span class="ped__action ped__action--delete" @click="deleteSkuOfList(data.item)">
                  <i class="fa-solid fa-trash"></i>
                </span>
              </template>

            </b-table>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import axios from '@axios'
import { BTable, BFormInput, BFormGroup, BRow, BCol, VBTooltip, BFormDatepicker } from 'bootstrap-vue'
import BCardCode from '@core/components/b-card-code'
import vSelect from 'vue-select'

export default {
  components: {
    BCardCode,
    BTable,
    BFormInput,
    BFormGroup,
    BFormDatepicker,
    BRow,
    BCol,
    vSelect,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  data() {
    return {
      columnasTable: [
        {
          key: 'referencia',
          label: 'Referencia',
          sortable: true,
        },
        {
          key: 'fecha',
          label: 'Fecha',
          sortable: true,
        },
        {
          key: 'aceptado',
          label: 'Estado',
          sortable: true,
        },
        {
          key: 'progreso',
          label: 'Progreso',
          sortable: false,
        },
        {
          key: 'total',
          label: 'Total',
          sortable: true,
        },
        {
          key: 'options',
          label: '',
          thStyle: { width: '180px' },
        },
      ],
      columnasSkuPedido: [
        {
          key: 'sku',
          label: 'SKU',
          sortable: true,
        },
        {
          key: 'cantidad',
          label: 'Cantidad',
          sortable: true,
          thStyle: { width: '120px' },
        },
        {
          key: 'completados',
          label: 'Fabricados',
          sortable: true,
          thStyle: { width: '100px' },
        },
        {
          key: 'fecha',
          label: 'Fecha estimada',
          sortable: true,
          thStyle: { width: '220px' },
        },
        {
          key: 'options',
          label: '',
          thStyle: { width: '60px' },
        },
      ],
      columnasSkus: [
        {
          key: 'sku',
          label: 'SKU',
          sortable: false,
          thStyle: { width: '20%' },
        },
        {
          key: 'cantidad',
          label: 'UD',
          sortable: false,
          thStyle: { width: '5%' },
        },
        {
          key: 'titulo',
          label: 'Nombre',
          sortable: false,
        },
      ],
      pedidos: [],
      pedidosBusqueda: [],
      buscar: '',
      pedidoSelect: { listaSku: [] },
      listSku: [],
      vistaPedido: false,
      listSkuName: [],
    }
  },

  methods: {
    getProgreso(item) {
      if (!item.total || item.total === 0) return 0
      return Math.min(100, Math.round((item.finalizado / item.total) * 100))
    },
    loadItems() {
      axios.post('/uso', { seccion: 'pedidos' })
      axios
        .get('/taller/pedidos')
        .then(response => response.data)
        .then(resPeticion => {
          this.pedidos = resPeticion.map(element => {
            const listaSku = JSON.parse(element.listaSku)
            const total = Array.isArray(listaSku) ? listaSku.reduce((sum, sku) => sum + parseInt(sku.cantidad || 0), 0) : 0
            return { ...element, listaSku, total }
          })
          this.pedidosBusqueda = [...this.pedidos].reverse()
        })

      axios
        .get('/articulos/variants/sku')
        .then(response => response.data)
        .then(resSku => {
          this.listSkuName = resSku
          this.listSku = resSku.map(objeto => objeto.sku)
        })
    },
    editarPedido(data) {
      this.pedidoSelect = data
      this.vistaPedido = true
    },
    deleteSkuOfList(data) {
      this.pedidoSelect.listaSku = this.pedidoSelect.listaSku.filter(item => item !== data)
    },
    deletePedido(data) {
      this.$swal({
        title: '¿Estas seguro que quieres borrar el pedido?',
        text: data.fecha,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Si, borrar',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          axios
            .post('/taller/pedidos/delete', data)
            .then(response => response.data)
            .then(() => {
              this.pedidos = this.pedidos.filter(objeto => objeto.id !== data.id)
              this.pedidosBusqueda = this.pedidos
              this.$swal({
                icon: 'success',
                title: 'Borrado',
                text: 'El pedido ha sido borrado',
                customClass: { confirmButton: 'btn btn-success' },
              })
            })
        }
      })
    },
    desArchivar(data) {
      axios
        .post('/taller/pedidos/archivar', { id: data.id, archivado: 0 })
        .then(response => response.data)
        .then(() => {
          this.$swal({
            icon: 'success',
            title: 'El pedido ' + data.referencia + ' se ha desarchivado correctamente',
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          })
          data.archivado = 0
        })
    },
    addSku() {
      this.pedidoSelect.listaSku.push({ cantidad: '', completados: '', fecha: '', sku: '', nuevo: true })
      window.scrollTo(0, document.body.scrollHeight)
    },
    crearPedido() {
      const fechaActual = new Date()
      const dia = fechaActual.getDate().toString().padStart(2, '0')
      const mes = (fechaActual.getMonth() + 1).toString().padStart(2, '0')
      const anio = fechaActual.getFullYear().toString()

      let dataSend = { fecha: `${dia}-${mes}-${anio}`, listaSku: [] }

      axios
        .post('/taller/pedidos/new', dataSend)
        .then(response => response.data)
        .then(res => {
          dataSend.id = res.id
          dataSend.aceptado = false
          dataSend.finalizado = 0
          dataSend.total = 0
          dataSend.referencia = res.ref

          this.pedidos.unshift(dataSend)
          this.pedidosBusqueda.unshift(dataSend)

          this.$swal({
            icon: 'success',
            title: 'Pedido creado',
            text: 'Referencia: ' + dataSend.referencia,
            customClass: { confirmButton: 'btn btn-success' },
          })

          this.editarPedido(dataSend)
        })
    },
    aceptarPedido(data) {
      if (data.listaSku.length == 0) {
        this.$swal({
          icon: 'error',
          title: 'No se puede aceptar un pedido sin articulos',
          text: 'Agrege primero los articulos.',
          customClass: { confirmButton: 'btn btn-success' },
        })
      } else {
        axios
          .post('/taller/pedidos/aceptar', data)
          .then(response => response.data)
          .then(() => {
            data.aceptado = true
            this.$swal({
              icon: 'success',
              title: 'Aceptado',
              text: 'El pedido se ha aceptado con exito.',
              customClass: { confirmButton: 'btn btn-success' },
            })
          })
          .catch(() => {
            this.$swal({
              icon: 'error',
              title: 'Error',
              text: 'Se ha producido un error al actualizar el pedido.',
              customClass: { confirmButton: 'btn btn-success' },
            })
          })
      }
    },
    guardarCambios() {
      this.pedidoSelect.listaSku = this.pedidoSelect.listaSku.map(({ nuevo, ...resto }) => resto)
      this.pedidoSelect.listaSku = this.pedidoSelect.listaSku.filter(item => item.sku !== null && item.sku !== '')

      this.pedidoSelect.listaSku.forEach(articuloPedido => {
        const articulo = this.listSkuName.find(articulo => articuloPedido.sku === articulo.sku)
        if (articulo) {
          articuloPedido.titulo = articulo.productTitle
        }
      })

      this.pedidoSelect.total = Array.isArray(this.pedidoSelect.listaSku)
        ? this.pedidoSelect.listaSku.reduce((sum, sku) => sum + parseInt(sku.cantidad || 0), 0)
        : 0

      axios
        .post('/taller/pedidos/update', this.pedidoSelect)
        .then(response => response.data)
        .then(() => {
          this.$swal({
            icon: 'success',
            title: 'Actualizado',
            text: 'El pedido se ha actualizado con exito.',
            customClass: { confirmButton: 'btn btn-success' },
          })
        })
    },
  },
  mounted() {
    this.loadItems()
  },
  watch: {
    buscar(val) {
      if (!val) {
        this.pedidosBusqueda = [...this.pedidos].reverse()
        return
      }
      const search = val.toLowerCase()
      this.pedidosBusqueda = this.pedidos.filter(p => {
        const ref = (p.referencia || '').toLowerCase()
        const fecha = (p.fecha || '').toLowerCase()
        const skus = Array.isArray(p.listaSku) ? p.listaSku.map(s => (s.sku || '').toLowerCase()).join(' ') : ''
        return ref.includes(search) || fecha.includes(search) || skus.includes(search)
      }).reverse()
    },
  },
}
</script>

<style lang="scss">
@import '../@core/scss/vue/libs/vue-select.scss';
</style>

<style lang="scss">
/* ═══ Tabla Pedidos ═══ */
.ped__table {
  margin-bottom: 0;

  thead th {
    background: #f8f9fb !important;
    border-bottom: 2px solid #e9ecf1 !important;
    border-top: none !important;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: #8a8e99;
    padding: 12px 14px;
    white-space: nowrap;
  }

  tbody td {
    padding: 10px 14px;
    vertical-align: middle;
    border-bottom: 1px solid #f0f1f4 !important;
    border-top: none !important;
    font-size: 13px;
    color: #5e5873;
    white-space: nowrap;
  }

  tbody tr {
    transition: background 0.15s;
    background: transparent !important;

    &:hover {
      background: #f9f8ff !important;
    }
  }
}

.ped__table--nested {
  thead th {
    background: #faf9fe !important;
    border-bottom: 1px solid #e9ecf1 !important;
    font-size: 10px;
  }

  tbody td {
    font-size: 12px;
    padding: 8px 14px;
  }
}
</style>

<style scoped>
/* ═══ Layout ═══ */
.ped { display: flex; flex-direction: column; gap: 18px; }

/* ═══ Header ═══ */
.ped__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  border-radius: 14px;
  padding: 12px 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
}

.ped__header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.ped__header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.ped__icon-title {
  display: flex;
  align-items: center;
  gap: 10px;
}

.ped__section-icon {
  width: 34px;
  height: 34px;
  border-radius: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  flex-shrink: 0;
}
.ped__section-icon--primary { background: #eeedfd; color: #7367f0; }

.ped__section-title { font-size: 15px; font-weight: 600; color: #3b4253; }
.ped__section-subtitle { font-size: 14px; color: #8a8e99; }

/* ═══ Card ═══ */
.ped__card {
  background: #fff;
  border-radius: 14px;
  padding: 20px 24px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  display: flex;
  flex-direction: column;
  gap: 14px;
}

/* ═══ Filtros ═══ */
.ped__filters {
  display: flex;
  align-items: flex-end;
  gap: 12px;
  flex-wrap: wrap;
}

.ped__filter-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 130px;
}
.ped__filter-item--wide { flex: 1; min-width: 200px; max-width: 350px; }

.ped__filter-label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #8a8e99;
  margin-bottom: 0;
}

/* ═══ Tabla card ═══ */
.ped__table-card {
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid #f0f1f4;
}

.ped__tabla-scroll {
  width: 100%;
  overflow-x: auto;
}

/* ═══ Referencia clicable ═══ */
.ped__ref {
  color: #7367f0;
  font-weight: 600;
  cursor: pointer;
  transition: color 0.15s;
}
.ped__ref:hover { color: #5a4fd6; text-decoration: underline; }

/* ═══ Badges ═══ */
.ped__badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 600;
}
.ped__badge--success { background: #e8fce8; color: #28c76f; }
.ped__badge--pending { background: #fff3e0; color: #ff9f43; }

/* ═══ Barra de progreso ═══ */
.ped__progress-wrap {
  display: flex;
  align-items: center;
  gap: 8px;
}

.ped__progress-bar {
  flex: 1;
  height: 6px;
  background: #f0f1f4;
  border-radius: 3px;
  overflow: hidden;
  min-width: 60px;
  max-width: 100px;
}

.ped__progress-fill {
  height: 100%;
  background: linear-gradient(135deg, #7367f0 0%, #9b8cf8 100%);
  border-radius: 3px;
  transition: width 0.3s;
}

.ped__progress-text {
  font-size: 11px;
  font-weight: 600;
  color: #8a8e99;
  white-space: nowrap;
}

/* ═══ Acciones ═══ */
.ped__actions { display: flex; align-items: center; gap: 4px; }

.ped__action {
  width: 28px;
  height: 28px;
  border-radius: 7px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.15s;
  font-size: 13px;
}

.ped__action--edit { color: #7367f0; background: #eeedfd; }
.ped__action--edit:hover { background: #7367f0; color: #fff; }
.ped__action--accept { color: #28c76f; background: #e8fce8; }
.ped__action--accept:hover { background: #28c76f; color: #fff; }
.ped__action--expand { color: #8a8e99; background: #f3f4f6; }
.ped__action--expand:hover { background: #e2e3e5; color: #5e5873; }
.ped__action--delete { color: #ea5455; background: #fce4e4; }
.ped__action--delete:hover { background: #ea5455; color: #fff; }
.ped__action--unarchive { color: #28c76f; background: #e8fce8; }
.ped__action--unarchive:hover { background: #28c76f; color: #fff; }

/* ═══ Detalle expandido ═══ */
.ped__details {
  padding: 8px 0 8px 40px;
}

.ped__details-table-wrap {
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #eeedfd;
}

/* ═══ SKU text ═══ */
.ped__sku-text {
  font-weight: 500;
  color: #3b4253;
}

/* ═══ Input cantidad ═══ */
.ped__input-qty {
  max-width: 90px;
  text-align: center;
}

/* ═══ Datepicker ═══ */
.ped__datepicker {
  max-width: 200px;
}

/* ═══ Botones ═══ */
.ped__btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 9px 18px;
  border-radius: 10px;
  border: none;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
}

.ped__btn--primary {
  background: linear-gradient(135deg, #7367f0 0%, #9b8cf8 100%);
  color: #fff;
  box-shadow: 0 4px 14px rgba(115, 103, 240, 0.35);
}
.ped__btn--primary:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(115, 103, 240, 0.45);
}

.ped__btn--outline {
  background: transparent;
  color: #7367f0;
  border: 1px solid #7367f0;
}
.ped__btn--outline:hover { background: #7367f0; color: #fff; }

.ped__btn--success {
  background: linear-gradient(135deg, #28c76f 0%, #48da89 100%);
  color: #fff;
  box-shadow: 0 4px 14px rgba(40, 199, 111, 0.35);
}
.ped__btn--success:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(40, 199, 111, 0.45);
}

.ped__btn-icon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  border: 1px solid #dfe3e8;
  background: #fff;
  color: #6e6b7b;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  transition: all 0.2s;
}
.ped__btn-icon:hover { background: #7367f0; color: #fff; border-color: #7367f0; }
</style>

<style lang="scss">
// ══════════ DARK MODE ══════════ (sin scoped: .dark-layout está en body)
// Paleta negra, misma que pedidos Vero
.dark-layout .ped {
  .ped__header,
  .ped__card { background: #1f1f1f; box-shadow: 0 0 0 1px #2c2c2c; }
  .ped__section-icon--primary { background: rgba(115, 103, 240, 0.14); }
  .ped__section-title,
  .ped__sku-text { color: #e4e6eb; }

  .ped__table-card { border-color: #2c2c2c; }
  .ped__details-table-wrap { border-color: #2c2c2c; }

  .ped__table {
    thead th { background: #161616 !important; border-bottom-color: #2c2c2c !important; color: #8e9099; }
    tbody td { border-bottom-color: #2c2c2c !important; color: #d0d2d6; }
    tbody tr:hover { background: #242424 !important; }
  }
  .ped__table--nested thead th { background: #161616 !important; border-bottom-color: #2c2c2c !important; }

  .ped__badge--success { background: rgba(40, 199, 111, 0.14); }
  .ped__badge--pending { background: rgba(255, 159, 67, 0.14); }
  .ped__progress-bar { background: #2c2c2c; }

  // Fondos claros de acciones → tintes (sin pisar el hover sólido)
  .ped__action--edit:not(:hover) { background: rgba(115, 103, 240, 0.14); }
  .ped__action--accept:not(:hover),
  .ped__action--unarchive:not(:hover) { background: rgba(40, 199, 111, 0.14); }
  .ped__action--delete:not(:hover) { background: rgba(234, 84, 85, 0.14); }
  .ped__action--expand:not(:hover) { background: #2c2c2c; color: #b4b7bd; }
  .ped__action--expand:hover { background: #3a3a3a; color: #e4e6eb; }

  .ped__btn-icon:not(:hover) { background: #1f1f1f; border-color: #2c2c2c; color: #b4b7bd; }
}
</style>
